import RosesProduct from "../../components/categories/RosesProduct";
import EventProductCard from "../../components/categories/EventProductCard";

const Evenements = () => {
  const products = [
    {
      id: "jardin-royal",
      name: "Jardin Royal",
      price: 149,
      image: "/images/evenement_produits/jardin_royal.jpg",
      description: "1 fleur pivoine + 50 fleurs"
    },
    {
      id: "jardin-elegant",
      name: "Jardin Elegant",
      price: 89,
      image: "/images/evenement_produits/jardin_elegant.jpg",
      description: "1 fleur pivoine + 29 fleurs"
    }
  ];

  return (
    <div className="section-padding">

      <h1 className="text-4xl font-bold mb-12">
        Vos Événements
      </h1>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

        {/* ROSES */}
        <RosesProduct />

        {/* AUTRES PRODUITS */}
        {products.map((product) => (
          <EventProductCard key={product.id} product={product} />
        ))}

      </div>

    </div>
  );
};

export default Evenements;